<template>
  <div class="stripe-charges">
    <p class="pull-right">
      <label class="label label-info label-margin" v-if="charge.amount_refunded > 0">Refunded</label>
    </p>
    <p>
      <strong class="card-title">Description: </strong><br class="show-br" />{{ charge.description }}<br/>
      <strong class="card-title">Amount: </strong><br class="show-br" />{{ charge.amount | stripe_currency }}<br/>
      <span v-if="charge.amount_refunded > 0"><strong class="card-title">Amount Refunded: </strong><br class="show-br" />{{ charge.amount_refunded | stripe_currency }}<br/></span>
      <strong class="card-title">Date Processed: </strong><br class="show-br" />{{ charge.created * 1000 | date_format }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'StripeCharges',
  props: {
    charge: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  ready () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// StripeCharges.vue?55aa662a